import { useState, useEffect } from "react";
import clsx from "clsx";

function isMobile() {
  return window.matchMedia("(pointer: coarse)").matches;
}

const Cursor = () => {
  const [position, setPosition] = useState({ x: -100, y: -100 });
  const [isHovering, setIsHovering] = useState(false);
  const [mobile, setMobile] = useState(isMobile());

  useEffect(() => {
    const handleResize = () => setMobile(isMobile());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (mobile) return; // Don't attach listeners on mobile

    const handleMouseMove = (e) => setPosition({ x: e.clientX, y: e.clientY });
    const handleMouseOver = (e) => {
      if (
        e.target.matches("a, .nav-dot, .skill-tag, .logo-main, .social-icon")
      ) {
        setIsHovering(true);
      }
    };
    const handleMouseOut = (e) => {
      if (
        e.target.matches("a, .nav-dot, .skill-tag, .logo-main, .social-icon")
      ) {
        setIsHovering(false);
      }
    };

    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseover", handleMouseOver);
    document.addEventListener("mouseout", handleMouseOut);
    return () => {
      document.removeEventListener("mousemove", handleMouseMove);
      document.removeEventListener("mouseover", handleMouseOver);
      document.removeEventListener("mouseout", handleMouseOut);
    };
  }, [mobile]);

  if (mobile) return null; // <--- Don't render cursor on mobile

  return (
    <div
      className={clsx("cursor", { hovering: isHovering })}
      style={{
        left: position.x,
        top: position.y,
        pointerEvents: "none",
        position: "fixed",
      }}
    />
  );
};

export default Cursor;
